import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Grid from '@material-ui/core/Grid'
import { List } from 'immutable'
import DateFnsUtils from '@date-io/date-fns'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import moment from 'moment'
import SelectList from 'components/common/SelectList'
import messages from 'routes/App/Dashboard/translate'
import Psfs from 'lib/psfs/Psfs'
import {
  fetchActiveSites,
  fetchActiveCages,
  setActiveCage,
  setActiveDate,
} from 'reducers/digitalLogbook/reducer'
import { setSiteContext } from 'reducers/profile/reducer'
import ProfileHelper from 'helpers/profile'

class FilterBar extends Component {
  componentDidMount() {
    this.props.fetchActiveSites()
  }

  shouldComponentUpdate(nextProps) {
    const { siteList, setSiteContext } = this.props

    if (
      siteList !== nextProps.siteList &&
      nextProps.siteList.size > 0 &&
      nextProps.activeSite === 0
    ) {
      const activeSite = nextProps.siteList.get(0)
      setSiteContext({ site: activeSite.id })

      return false
    }

    return true
  }

  onSiteChange = value => {
    const {
      fetchActiveCages,
      setSiteContext,
      setActiveCage,
      activeSite,
    } = this.props

    if (value) {
      const psfs = new Psfs()
      psfs.addFields(['id', 'containerName'])
      psfs.addFilter('site', value.index)
      fetchActiveCages({ psfs })
      setActiveCage(0)

      if (activeSite !== value.index) {
        setSiteContext({ site: value.index })
      }
    }
  }

  onLocusChange = value => {
    if (value) {
      this.props.setActiveCage(value.index)
    }
  }

  // TODO: костыль от материаловствого эффекта двойного апдейта при выборе даты и наличи трушного свойства autoOk
  dateChange = false

  onDateChange = value => {
    if (!this.dateChange) {
      this.props.setActiveDate(moment(value))
      this.dateChange = true
    } else {
      this.dateChange = false
    }
  }

  render() {
    const {
      activeDate,
      siteList,
      locusList,
      activeSite,
      activeCage,
      intl: { formatMessage },
    } = this.props
    const locale = ProfileHelper.getCurrentLocale()

    return (
      <Grid container spacing={1}>
        <Grid item lg={3} md={4} sm={6} xs={12} className="avatar-block">
          <SelectList
            variant="outlined"
            name="site"
            label={formatMessage(messages.site_list)}
            onChange={this.onSiteChange}
            list={siteList}
            value={activeSite}
            map={{
              index: 'id',
              text: item => (
                <span>
                  {item.name}
                  &nbsp;
                  <span>{`(${item.locus_count})`}</span>
                </span>
              ),
            }}
          />
        </Grid>

        <Grid item lg={2} md={2} sm={3} xs={6} className="avatar-block">
          <SelectList
            name="locus"
            onChange={this.onLocusChange}
            value={activeCage}
            label={formatMessage(messages.locus)}
            list={List(
              [
                { id: 0, containerName: formatMessage(messages.allUnits) },
              ].concat(locusList.toArray()),
            )}
            disabled={locusList.size === 0}
            map={{
              index: 'id',
              text: 'containerName',
            }}
          />
        </Grid>

        <Grid item lg={2} md={2} sm={3} xs={6} className="avatar-block">
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            <DatePicker
              autoOk
              fullWidth
              disableToolbar
              disableFuture
              variant="inline"
              format="MM/dd/yyyy"
              id="date-picker-inline"
              label="Date"
              value={activeDate}
              onChange={this.onDateChange}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    )
  }
}

export default connect(
  state => ({
    siteList: state.getIn(['digitalLogbook', 'siteList']),
    locusList: state.getIn(['digitalLogbook', 'locusList']),
    activeSite: state.getIn(['profile', 'siteId']),
    activeCage: state.getIn(['digitalLogbook', 'activeCage']),
    activeDate: state.getIn(['digitalLogbook', 'activeDate']),
  }),
  {
    fetchActiveSites,
    fetchActiveCages,
    setSiteContext,
    setActiveCage,
    setActiveDate,
  },
)(injectIntl(FilterBar))
